<template>
    <div>
        <div class="Panel">
            <div class="Panel__heading">Members</div>
            <div class="Panel__body">
                <div class="row">
                    <div class="col-md-3 col-md-offset-9">
                        <input type="text"
                               class="Form__text"
                               placeholder="Search by name or number..."
                               v-model.trim="search"
                        >
                    </div>
                </div>
                <div class="TableResponsive">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th>Membership Number</th>
                            <th>Member Name</th>
                            <th>Status</th>
                            <th>New Status</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <td>
                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="newMember.membership_number"
                                       @keyup.enter="createMember"
                                >
                                <div class="Form__error">{{ newMembershipNumberError }}</div>
                            </td>
                            <td>
                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="newMember.name"
                                       @keyup.enter="createMember"
                                >
                                <div class="Form__error">{{ newMemberNameError }}</div>
                            </td>
                            <td>
                                <div class="Form__select">
                                    <select v-model="newMember.active">
                                        <option value="0">In-Active</option>
                                        <option value="1">Active</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <div class="Form__select">
                                    <select v-model="newMember.payment_status">
                                        <option value="2">Paid</option>
                                        <option value="1">Part Paid</option>
                                        <option value="0">Unpaid</option>
                                    </select>
                                </div>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger Table__control--create"
                                   @click.prevent="clearNewMember"
                                >
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success Table__control--create"
                                   @click.prevent="createMember"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="member in paginatedMembers">
                            <td class="Table__cell--form-field">
                                <input type="text"
                                       class="Form__text"
                                       v-if="isBeingEdited(member.id)"
                                       v-model.trim="editing[member.id].membership_number"
                                       @keyup.enter="updateMember(editing[member.id])"
                                >
                                <span v-else>
                                    {{ member.membership_number }}
                                </span>
                            </td>
                            <td class="Table__cell--form-field">
                                <input type="text"
                                       class="Form__text"
                                       v-if="isBeingEdited(member.id)"
                                       v-model.trim="editing[member.id].name"
                                       @keyup.enter="updateMember(editing[member.id])"
                                >
                                <span v-else>{{ member.name }}</span>
                            </td>
                            <td class="Table__cell--form-field">
                                <div class="Form__select" v-if="isBeingEdited(member.id)">
                                    <select v-model="editing[member.id].active">
                                        <option value="0">In-Active</option>
                                        <option value="1">Active</option>
                                    </select>
                                </div>

                                <span v-else>{{ status(member) }}</span>
                            </td>
                            <td class="Table__cell--form-field">
                                <div class="Form__select" v-if="isBeingEdited(member.id)">
                                    <select v-model="editing[member.id].payment_status">
                                        <option :value="2">Paid</option>
                                        <option :value="1">Part Paid</option>
                                        <option :value="0">Unpaid</option>
                                    </select>
                                </div>

                                <span v-else>{{ paymentStatus(member) }}</span>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="endEdit(member.id)"
                                   v-if="isBeingEdited(member.id)"
                                >
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="confirmDelete(member.id)"
                                   v-else
                                >
                                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success"
                                   @click.prevent="updateMember(editing[member.id])"
                                   v-if="isBeingEdited(member.id)"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--primary"
                                   @click.prevent="editMember(member)"
                                   v-else
                                >
                                    <i class="fa fa-pencil fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="Pagination" v-show="pages > 1">
                    <ul class="Utility__list-inline">
                        <li class="Pagination__page">
                            <a href="#" @click.prevent="showFirstPage">
                                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                            </a>
                        </li><li :class="pageClasses(page)" v-for="page in pageLinks">
                        <a href="#" @click.prevent="showPage(page)">{{ page }}</a>
                    </li><li class="Pagination__page">
                        <a href="#" @click.prevent="showLastPage">
                            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        </a>
                    </li>
                    </ul>
                </div>
            </div>
        </div>

        <confirm :on-yes="deleteMember" :on-no="cancelDelete" ref="confirmation">
            <span slot="heading">Confirm Delete</span>
            Are you sure you want to delete the member?
        </confirm>
    </div>
</template>

<script>
    import Pagination from './../mixins/pagination';

    export default {
        data() {
            return {
                newMember: {
                    membership_number: '',
                    name: '',
                    active: 1,
                    payment_status: 2,
                },
                newMembershipNumberError: '',
                newMemberNameError: '',
                members: [],
                editing: {},
                deleting: null,
                search: '',
            }
        },

        mixins: [Pagination],

        props: {
            currentMembers: {
                required: true
            }
        },

        mounted() {
            this.members = JSON.parse(this.currentMembers);
        },

        computed: {
            sortedMembers() {
                let members = [];

                if (this.search) {
                    members = _.filter(this.members, member => {
                        let regex = RegExp(this.search, 'i');

                        return member.name.match(regex) || member.membership_number.match(regex);
                    });
                } else {
                    members = this.members;
                }


                return _.sortBy(members, (member) => {
                    return member.name.toLowerCase();
                });
            },

            pages() {
                return Math.ceil(this.sortedMembers.length / this.pagination.perPage);
            },

            paginatedMembers() {
                return this.sortedMembers.slice(this.currentPageStart, this.currentPageEnd);
            },
        },

        methods: {
            isActive(member) {
                return member.active == 1;
            },

            status(member) {
                return this.isActive(member) ? 'Active' : 'In-Active';
            },

            paymentStatus(member) {
                switch (parseInt(member.payment_status)) {
                    case 0:
                        return 'Unpaid';

                    case 1:
                        return 'Part Paid';

                    case 2:
                        return 'Paid';
                }
            },

            createMember() {
                this.newMembershipNumberError = '';
                this.newMemberNameError = '';

                if (this.newMember.membership_number == '') {
                    return this.newMembershipNumberError = 'Membership Number is required';
                }

                if (this.newMember.name == '') {
                    return this.newMemberNameError = 'Member Name is required';
                }

                this.$http.post('/system-settings/account-management/members', this.newMember)
                    .then((response) => {
                        this.newMember.membership_number = '';
                        this.newMember.name = '';
                        this.newMember.active = 1;
                        this.newMember.active = 2;

                        this.members.push(response.data);
                    });
            },

            clearNewMember() {
                this.newMember.number = '';
                this.newMember.name = '';
                this.newMember.active = 1;
                this.newMember.payment_status = 2;
                this.newMembershipNumberError = '';
                this.newMemberNameError = '';
            },

            deleteMember() {
                this.$refs.confirmation.show = false;

                this.$http.delete('/system-settings/account-management/members/' + this.deleting)
                    .then(() => {
                        this.members =_.reject(this.members, (member) => {
                            return member.id == this.deleting;
                        })

                        _.defer(() => {
                            this.deleting = null;
                        });
                    });

            },

            editMember(member) {
                _.set(this.editing, member.id, {
                    id: member.id,
                    membership_number: member.membership_number,
                    name: member.name,
                    active: member.active,
                    payment_status: member.payment_status,
                });

                this.$forceUpdate();
            },

            endEdit(id) {
                _.unset(this.editing, id);

                this.$forceUpdate();
            },

            isBeingEdited(id) {
                return _.has(this.editing, id);
            },

            updateMember(member) {
                if (member.membership_number == '' || member.name == '') {
                    this.endEdit(member.id);
                }

                this.$http.patch('/system-settings/account-management/members/' + member.id, member)
                    .then(() => {
                        let m = _.find(this.members, ['id', member.id]);

                        m.membership_number = member.membership_number;
                        m.name = member.name;
                        m.active = member.active;
                        m.payment_status = member.payment_status;

                        this.endEdit(member.id);
                    })
            },

            confirmDelete(id) {
                this.deleting = id;
                this.$refs.confirmation.show = true;
            },

            cancelDelete() {
                this.$refs.confirmation.show = false;
                this.deleting = null;
            }
        },
    }
</script>
